export const opacityEnter = { enterFrom: "opacity-0", enterTo: "opacity-100" };
const opacityLeave = { leaveFrom: "opacity-100", leaveTo: "opacity-0" };
export const opacityTransition = { ...opacityEnter, ...opacityLeave };
export const transitionSimpleLeaveStyles = {
  leave: "transition ease-in duration-100",
  ...opacityLeave,
};

const INOUTTRANSITION_STYLES = "transition ease-in-out transform";

const MENU_TRANSITION_STYLES = `${INOUTTRANSITION_STYLES} duration-300`;
export const SLIDEOVER_TRANSITION_STYLES = `${INOUTTRANSITION_STYLES} duration-500`;

export const menuTransition = {
  enter: MENU_TRANSITION_STYLES,
  leave: MENU_TRANSITION_STYLES,
};

export const ENTER_TO = "translate-x-0";

export const opacityScaleTransition = {
  enter: "transition ease-out duration-100",
  enterFrom: "transform opacity-0 scale-95",
  enterTo: "transform opacity-100 scale-100",
  leave: "transition ease-in duration-75",
  leaveFrom: "transform opacity-100 scale-100",
  leaveTo: "transform opacity-0 scale-95",
};
